/** @prettier */
import { delay } from 'redux-saga';

import { all, call, put, race, select, take, takeEvery } from 'redux-saga/effects';

import { PAGE_VISIBILITY_CHANGE } from '@xanadu/ui-shared/modules/application/actions';
import {
  SET_ACTIVE_MAIN_TAB,
  SET_ACTIVE_TAB,
  SET_COLLAPSED as SET_BETSLIP_COLLAPSED,
} from '@xanadu/ui-shared/modules/betslip/actions';
import {
  FETCH_OPEN_OFFERS,
  fetchOpenOffersRequest,
  updateAllOffersByServer,
} from '@xanadu/ui-shared/modules/openOffers/actions';
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from '@xanadu/ui-shared/modules/userSession/actions';

import { MOBILE_BREAKPOINT } from '../../constants';

import { UPDATE_SIDEBAR } from '../sidebar/actions';

function* pollData() {
  // For Debug
  // console.log('[polling] - enter');
  let pollingEnabled = false;

  while (true) {
    // console.log('[polling] - enter loop');
    const { collapsed, activeTab } = yield race({
      collapsed: take(SET_BETSLIP_COLLAPSED),
      activeTab: take(SET_ACTIVE_TAB),
      fetchOffers: take(FETCH_OPEN_OFFERS),
    });

    // console.log(`[polling] - Collapsed: ${collapsed} - FetchOffers: ${fetchOffers} `);

    const widthSize = yield select((state) => state.getIn(['application', 'widthSize']));
    let currentBetslipTab = yield select((state) => state.getIn(['betslip', 'activeTab']));
    const currentBetslipCollapsed = yield select((state) => state.getIn(['betslip', 'collapsed']));
    const currentSidebarContent = yield select((state) =>
      state.getIn(['local', 'sidebar', 'content'])
    );
    const currentSidebarVisible = yield select((state) =>
      state.getIn(['local', 'sidebar', 'visible'])
    );

    const isMobile = widthSize <= MOBILE_BREAKPOINT;

    // console.log(
    //   `[polling]
    //   - collapsed: ${collapsed}
    //   - activeTab: ${activeTab}
    //   - widthSize: ${widthSize}
    //   - currentBetslipCollapsed: ${currentBetslipCollapsed}
    //   - currentBetslipTab: ${currentBetslipTab}
    //   - currentSidebarContent: ${currentSidebarContent}
    //   - currentSidebarVisible: ${currentSidebarVisible} - isMobile: ${isMobile} `
    // );

    let eligibleToPoll =
      (collapsed && !collapsed.payload && currentBetslipTab === 'active') ||
      (activeTab && ['active', 'open'].includes(activeTab.payload)) ||
      (!currentBetslipCollapsed && currentBetslipTab === 'active' && !activeTab && !collapsed);

    // console.log(`[polling] - eligibleToPoll: ${eligibleToPoll} `);

    if (isMobile) {
      if (currentSidebarContent === 'betslip' && currentSidebarVisible) {
        eligibleToPoll = true;
      } else {
        // console.log(`[polling] - wait for sidebar`);
        const { payload: activeSidebar } = yield take(UPDATE_SIDEBAR);

        eligibleToPoll = activeSidebar.content === 'betslip' && activeSidebar.visible;

        // console.log(`[polling] - after sidebar - eligibleToPoll: ${eligibleToPoll} `);
      }
    }

    if (eligibleToPoll) {
      pollingEnabled = true;
    }

    while (pollingEnabled) {
      currentBetslipTab = yield select((state) => state.getIn(['betslip', 'activeTab']));

      const { tabChange, sidebarChange, logout, mainActiveTab, betslipCollapsed } = yield race({
        task: delay(3000),
        tabChange: take(SET_ACTIVE_TAB),
        logout: take(LOGOUT_SUCCESS),
        mainActiveTab: take(SET_ACTIVE_MAIN_TAB),
        betslipCollapsed: take(SET_BETSLIP_COLLAPSED),
        sidebarChange: take(UPDATE_SIDEBAR),
      });

      const perPage = yield select((state) => state.getIn(['openOffers', 'perPage']));

      const tabChanged = tabChange && tabChange.payload;
      const isPlaceTabUpdate = tabChange && !['active', 'open'].includes(tabChanged);
      const isCurrentActiveTab = ['active', 'open'].includes(currentBetslipTab);

      // console.log(
      //   '[polling]',
      //   ` - isPlaceTabUpdate: ${isPlaceTabUpdate}
      //     - isCurrentActiveTab: ${isCurrentActiveTab}
      //     - ${JSON.stringify({ tabChange, sidebarChange, logout, mainActiveTab, betslipCollapsed })}`
      // );

      if (
        (isPlaceTabUpdate && isCurrentActiveTab) ||
        !isCurrentActiveTab ||
        sidebarChange ||
        logout ||
        (mainActiveTab && mainActiveTab.payload !== 'singles') ||
        (betslipCollapsed && betslipCollapsed.payload)
      ) {
        pollingEnabled = false;
      } else {
        const visibleUpdate = yield select((state) => state.getIn(['application', 'visible']));

        if (visibleUpdate) {
          pollingEnabled = true;

          if (!tabChanged) {
            yield put(fetchOpenOffersRequest({ offset: 0, perPage }));
          }

          // console.log('[polling] - fire request');
        } else {
          // eslint-disable-next-line no-console
          console.info('Open offers queued');
          yield take(PAGE_VISIBILITY_CHANGE);
          yield put(fetchOpenOffersRequest({ offset: 0, perPage }));

          // console.log('[polling] - fire request');
        }
      }
    }
  }
}

function* handleLogin() {
  const { cancel } = yield race({
    task: call(pollData),
    cancel: take(LOGOUT_SUCCESS),
  });

  if (cancel) {
    yield put(updateAllOffersByServer([]));
  }
}

export default function* root() {
  yield all([takeEvery(LOGIN_SUCCESS, handleLogin)]);
}
